/**
 * @flow
 * @format
 */

import React from 'react';
import cc from 'classcat';
import _ from 'lodash';

import { branch } from '~/utils';
import Aux from '~/utils/react-aux';

import type { ChartDataType, ChartInfoType } from '~/modules/design/types';

import MultiLineGraph from '../MultiLineGraph';
import LineGraph from '../LineGraph';

import classes from './ChartLineGraph.scss';

type PropsType = {
  aspectRatio: string,
  chartArea?: Array<*>,
  chartData: ChartDataType,
  chartInfo: ChartInfoType,
  chartMarker?: {
    [key: string]: number,
  },
  graphNum: string | number,
  height: ?number,
  resize: ?boolean,
  viewBox?: ?ViewBox,
  width: ?number | string,
  legend: ?string,
};

// eslint-disable-next-line react/prefer-stateless-function
export class ChartLineGraph extends React.Component<PropsType, *> {
  static defaultProps = {
    aspectRatio: 'xMidYMid meet',
    chartArea: [],
    chartData: {},
    chartInfo: {},
    chartMarker: {},
    graphNum: '#',
    height: null,
    legend: 'vertical',
    viewBox: {
      x: 0,
      y: 0,
      width: 475,
      height: 200,
    },
    width: null,
    resize: false,
  };

  props: PropsType; // eslint-disable-line react/sort-comp

  render() {
    // Set up our props for later
    const props = {
      area: this.props.chartArea,
      data: this.props.chartData,
      labels: this.props.chartInfo,
      markers: this.props.chartMarker,
      width: this.props.width,
      height: this.props.height,
      viewBox: this.props.viewBox,
      aspectRatio: this.props.aspectRatio,
      legend: this.props.legend,
    };

    const multiLine =
      Object.keys(this.props.chartData).length > 3 ||
      (this.props.chartData['Critical Load'] !== undefined &&
        this.props.chartData['Max Load']) !== undefined;

    const Graph = multiLine ? MultiLineGraph : LineGraph;

    return (
      <Aux>
        <div className={classes.graphWrapper}>
          <Graph {...props} />
        </div>
        {branch(
          _.isString(this.props.chartInfo.Detail),
          <div className={cc([classes.chartDetails, 'px-5 pb-5 pt-0 d-flex'])}>
            <div className="w-75">{this.props.chartInfo.Detail}</div>
          </div>,
        )}
      </Aux>
    );
  }
}

export default ChartLineGraph;



// WEBPACK FOOTER //
// ./src/components/ChartLineGraph/ChartLineGraph.js